import { createFileRoute, redirect } from '@tanstack/react-router'

/** Seção sem tela própria: manda para a primeira tab. */
export const Route = createFileRoute('/_authed/mais-opcoes/')({
  beforeLoad: () => {
    throw redirect({ to: '/mais-opcoes/fechamento-de-mes' })
  },
})
